import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, CardContainer, Input, Table } from "../../../components"
import { ADDDAFTARONLINESHOP, DAFTARONLINESHOP } from "../../../routes/routesNames";
import { useEffect } from "react";
import { UseGet } from "../../../hooks/api";
import { UseTable } from "../../../hooks";
import columns from "./column";
import ImportModalSecond from "../../../components/molecules/importModalSecond";


const DaftarOnlineshop = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!location.state) {
            navigate(DAFTARONLINESHOP);
        }
    }, []);

    const {
        filter,
        isLoading,
        data,
        error,
        totalPages,
        handlePagination,
        handleLimit,
        handleFilter,
    } = UseGet(`/v1/official_online_shop`)

    const {
        isLoading: isLoadingPost,
        dataRemove,
        handleSelected,
        handleRemove
    } = UseTable();

    return (
        <div>
            <CardContainer >
                <div className="d-flex flex-row justify-content-between">
                    <Input type="search" id="search" placeholder="Cari Store" onChange={handleFilter} />
                    {
                        dataRemove.length === 0 ?
                            <div className="d-flex flex-row">
                                <ImportModalSecond
                                    urlImport={`${process.env.REACT_APP_API_URL}/v1/official_online_shop/upload_excel`}
                                    urlDownload={`${process.env.REACT_APP_API_URL}/v1/official_online_shop/blank_template_excel`}
                                    title={"Import"}
                                />
                                <Link to={ADDDAFTARONLINESHOP} state={location.state} >
                                    <Button title="Tambah Store" className="btn btn-primary" isSmall />
                                </Link>
                            </div>
                            :
                            <Button
                                isLoading={isLoadingPost}
                                onClick={() => handleRemove('/v1/official_online_shop/delete')}
                                title="Hapus Store"
                                className="btn btn-danger" isSmall />
                    }
                </div>
                <Table
                    filter={filter}
                    isLoading={isLoading}
                    error={error}
                    data={data}
                    totalPages={totalPages}
                    handlePagination={handlePagination}
                    handleLimit={handleLimit}
                    handleChangeSelect={handleSelected}
                    columns={columns(location.state)} />
            </CardContainer>
        </div>
    )
}
export default DaftarOnlineshop